import { render, staticRenderFns } from "./menu.vue?vue&type=template&id=12c7c8a8&scoped=true"
import script from "./menu.vue?vue&type=script&lang=js"
export * from "./menu.vue?vue&type=script&lang=js"
import style0 from "./menu.vue?vue&type=style&index=0&id=12c7c8a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c7c8a8",
  null
  
)

export default component.exports